import * as React from 'react';
import { InlineText2, Input, InputAdornment } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { TNumberInputs } from '../../types/filters';
import { TInputSize } from '../../types/inputSize';
import * as styles from './InputNumberRange.css';

interface IInputNumberRangeProps {
  title?: string;
  min: TNumberInputs;
  max: TNumberInputs;
  error: boolean;
  onChange: (type: 'min' | 'max') => (e: React.SyntheticEvent, value: string) => void;
  onBlur: () => void;
  rightAdornment?: string;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  size: TInputSize;
}

export function InputNumberRange({
  title,
  min,
  max,
  error,
  onBlur,
  onChange,
  rightAdornment,
  minPlaceholder = 'от:',
  maxPlaceholder = 'до:',
  size,
}: IInputNumberRangeProps) {
  const rightAdornmentComponent = React.useMemo(
    () => (rightAdornment ? <InputAdornment>{rightAdornment}</InputAdornment> : null),
    [rightAdornment],
  );

  return (
    <div>
      <InlineText2>{title}</InlineText2>

      <div className={clsx(styles['input__wrapper'], { [styles['input__wrapper--m']]: size === 'M' })}>
        <Input
          placeholder={minPlaceholder}
          rightAdornment={min ? rightAdornmentComponent : undefined}
          value={min ? String(min) : undefined}
          onChange={onChange('min')}
          onBlur={onBlur}
          invalid={error}
          type="number"
        />
        <Input
          placeholder={maxPlaceholder}
          rightAdornment={max ? rightAdornmentComponent : undefined}
          value={max ? String(max) : undefined}
          onChange={onChange('max')}
          onBlur={onBlur}
          invalid={error}
          type="number"
        />
      </div>
    </div>
  );
}
